<template>
  <b-col md="12">
    <section class="hotel">
      <h3 class="hotel__name">{{ confirm.bookingVoucher.property.name }}</h3>
      <div class="hotel__info">
        <div class="hotel__info-item">
          <vb-icon class="hotel__info-icon mr-1" :name="'pin'" :color="sass('primary')" :size="14" />
          <span class="hotel__info-label">
            {{ confirm.bookingVoucher.property.address }},
            {{ confirm.bookingVoucher.property.postal_code }}
            {{confirm.bookingVoucher.property.city }}
            {{ confirm.bookingVoucher.property.country_code }}
          </span>
        </div>
        <div class="hotel__info-item" v-if="confirm.bookingVoucher.property.phone !== ''">
          <vb-icon class="hotel__info-icon mr-1" :name="'phone'" :color="sass('primary')" :size="14" />
          <span class="hotel__info-label">{{ confirm.bookingVoucher.property.phone }}</span>
        </div>
        <div class="hotel__info-item" v-if="confirm.bookingVoucher.property.email !== ''">
          <vb-icon class="hotel__info-icon mr-1" :name="'email'" :color="sass('primary')" :size="14" />
          <span class="hotel__info-label">{{ confirm.bookingVoucher.property.email }}</span>
        </div>
      </div>
      <div class="hotel__wrap">
        <div class="hotel__room" v-for="(room, room_index) in confirm.bookingVoucher.rooms" :key="_uid + room_index">
          <span class="hotel__room-index">
            Camera {{ room_index +1 }}: <span class="semibold">{{ room.name }}</span>
          </span>
          <div class="hotel__room-mealplan">
            <template v-if="room.mealplan.length">
              <template v-for="(value, key) in room.mealplan">
                <div class="hotel__room-meal" v-if="value.included" :key="_uid + 'mealplan' + key">
                  <span class="hotel__room-meal_name">{{ get_mealplan(key).name }}</span>
                  <span class="hotel__room-meal_price" v-if="value.price_per_person_per_night">
                  (€ {{ value.price_per_person_per_night }} a persona per notte)
                </span>
                </div>
              </template>
            </template>
            <span v-else>{{ room.mealplan_label }}</span>
          </div>
        </div>
      </div>
      <div class="hotel__key">
        <key-info class="recap__info-key" :hotel="confirm.bookingVoucher" />
      </div>
    </section>
  </b-col>
</template>

<script>
import { get_mealplan } from "@bookingv3/resources"
import KeyInfo from '@bookingv3/components/blocks/key-info'

export default {
  name: 'hotel',

  components: {
    'key-info': KeyInfo,
  },

  props: {
    confirm: Object
  },

  data() {
    return {
    }
  },

  computed: {
  },

  created() {
    this.get_mealplan = get_mealplan
  },

  mounted() {
  },

  methods: {
  },
}
</script>

<style lang="scss" scoped>

  .hotel {
    margin-top: $grid-gutter-width*2;

    &__name {
      font-size: $font-size-xl;
      margin-bottom: 10px;
    }

    &__info {
      display: flex;
      align-items: center;
      padding-bottom: 10px;
      border-bottom: 1px solid $gray-300;

      @media print {
        border-bottom: 0;
      }

      &-item {
        display: flex;
        align-items: center;
        margin-right: $grid-gutter-width/2;
      }

      &__label {
        font-size: $font-size-lg;
      }
    }

    &__wrap, &__key {
      margin-top: $grid-gutter-width/2;
      background-color: $white;
      padding: 20px;
      border-radius: 10px;

      @media print {
        //display: none;
      }

      &:empty {
        display: none;
      }
    }

    &__room {
      display: flex;
      align-items: center;
      border-bottom: 1px solid $gray-200;
      padding-bottom: 10px;
      margin-bottom: 10px;

      &:last-child {
        margin-bottom: 0;
        padding-bottom: 0;
        border-bottom: 0;
      }

      &-index {
        margin-right: 20px;
      }

      &-mealplan {
        display: flex;
        align-items: center;

        &_icon {
          margin-right: 6px;
        }
      }

      &-meal {
        margin-right: 5px;
        color: $success;

        &:last-child {
          &:after {
            display: none;
          }
        }

        &:after {
          content: ',';
        }

        &_price {
          font-size: $font-size-md;
          margin-left: 3px;
        }
      }
    }
  }

</style>